<template>
  <div class="Operation">
    <div class="operation_container clearfix">
      <slot name="info"></slot>
    </div>

    <!-- Daily Quotation -->
    <div class="daily_quotation">
      <title-temp title="Daily Quotation"></title-temp>
      <!-- <el-select v-model="dailySelect" placeholder="please select" class="qurarter_cls">
        <el-option
          v-for="item in Config.options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>-->
      <!-- <table-list :column="Config.daily" :tableData="dailyData"></table-list> -->
      <!-- <el-date-picker
        v-model="KDatePicker"
        type="daterange"
        :picker-options="pickerOptions"
        start-placeholder="Start Date"
        end-placeholder="End Date"
        align="right"
        value-format="yyyy-MM-dd"
        @change="getQuotationData"
      ></el-date-picker>-->

      <el-select
        v-model="rangevalue"
        clearable
        placeholder="Select the range"
        @change="rangeChange"
      >
        <el-option
          v-for="item in rangeOption"
          :key="item.label"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>

      <el-date-picker
        class="search-chart"
        v-model="datePickerDouble.startDate"
        type="date"
        size="mini"
        value-format="yyyy-MM-dd"
        placeholder="Start Date"
        :picker-options="pickerOptionsStart"
      ></el-date-picker>
      <el-date-picker
        class="search-chart"
        v-model="datePickerDouble.endDate"
        type="date"
        size="mini"
        value-format="yyyy-MM-dd"
        placeholder="End Date"
        :picker-options="pickerOptionsEnd"
      ></el-date-picker>
      <el-button
        type="primary"
        icon="el-icon-search"
        circle
        size="mini"
        :disabled="!dateSearchDisabled"
        @click="getQuotationData"
      ></el-button>

      <k-charts :dailyKData="dailyKData"></k-charts>
    </div>

    <!-- Monthly Pricing series -->
    <!-- <div class="monthly_pricing_series">
      <title-temp title="Monthly Pricing series"></title-temp>
      <table-list :column="Config.monthlyPricing" :tableData="monthlyPricingData"></table-list>
    </div>-->

    <!-- Dividends and Bonus Shares -->
    <div class="Dividends">
      <title-temp title="Dividends and Bonus Shares"></title-temp>
      <table-list :column="Config.dividend" :tableData="dividendData"></table-list>
    </div>

    <!-- Performance Forecast -->
    <!-- <div class="performance_forecast">
      <title-temp title="Performance Forecast"></title-temp>
      <el-select v-model="performanceQuarter" placeholder="please select" class="qurarter_cls">
        <el-option
          v-for="item in quarterOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <table-list :column="Config.performance" :tableData="performanceData"></table-list>
    </div>-->

    <!-- Annual stock valuation -->
    <!-- <div class="annual_stock_valuation">
      <title-temp title="Annual stock valuation"></title-temp>
      <double-table :tableData="annualStockData"></double-table>
    </div>-->

    <!-- CA Summary -->
    <div class="ca_ummary">
      <title-temp title="Company announcement summary"></title-temp>
      <table-list :column="Config.caSummary" :tableData="caSummaryData">
        <template slot="other">
          <el-table-column label="Summary">
            <template slot-scope="scope">
              <span>{{getFirstSentence(scope.row.summary)}}</span>
              <el-button
                @click="viewDetail(scope.row.summary)"
                type="text"
                size="small"
                class="viewBt"
              >Check the details</el-button>
            </template>
          </el-table-column>
        </template>
      </table-list>
    </div>
    <detail-dialog :dialogVisible="dialogVisible" :content="content" @closeDialog="closeDialog"></detail-dialog>
  </div>
</template>

<script>
import TitleTemp from "common/components/Title";
import TableForm from "common/components/tableForm";
import TableList from "common/components/table";
import DoubleTable from "./tableDoubleColumn";

import Config from "conf/Operation";
import Quarter from "conf/Quarter";

import KCharts from "../KCharts";

import DetailDialog from "./DetailDialog";

import {
  getKQuotation,
  getBasic,
  getDividend,
  getSummary
} from "common/js/http/v2Api";

const now = new Date();
const last30Day = [now.getTime() - 3600 * 1000 * 24 * 30, now];
const last90Day = [now.getTime() - 3600 * 1000 * 24 * 90, now];
const last180Day = [now.getTime() - 3600 * 1000 * 24 * 180, now];
const lastYear = [now.getTime() - 3600 * 1000 * 24 * 365, now];

export default {
  components: {
    TitleTemp,
    TableForm,
    TableList,
    DoubleTable,
    KCharts,
    DetailDialog
  },

  data() {
    return {
      Config,
      quarterOptions: Quarter,

      id: this.$route.query.id,
      code: this.$route.query.code,

      dailySelect: 30,
      dailyData: [],
      dailyKData: [],

      //monthlyPricingData
      // monthlyPricingData: [{ a: "monthlyPricing" }],

      //dividendData
      dividendData: [],

      //performanceQuarter
      performanceQuarter: 1,
      performanceData: [],

      // annualStockData
      annualStockData: [{ year: "2019", a: "annualStockData" }],

      // caSummaryData
      caSummaryData: [],

      dialogVisible: false,
      content: "",
      f10Id: "",
      // k线图 配置
      KDatePicker: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "last 30 days",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "last 90 days",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "last 180 days",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "last year",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },

      rangevalue: "",

      rangeOption: [
        {
          label: "last 30 days",
          value: last30Day
        },
        {
          label: "last 90 days",
          value: last90Day
        },
        {
          label: "last 180 days",
          value: last180Day
        },
        {
          label: "last year",
          value: lastYear
        }
      ],

      // 日期
      datePickerDouble: {
        startDate: "",
        endDate: ""
      },
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.datePickerDouble.endDate;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.datePickerDouble.startDate;
          if (beginDateVal) {
            return (
              time.getTime() <
              new Date(beginDateVal).getTime() - 1 * 24 * 60 * 60 * 1000
            );
          }
        }
      }
    };
  },

  created() {
    this.getCurrentDate();
    this.getF10Id();
  },

  methods: {
    rangeChange() {
      if (this.rangevalue && this.rangevalue.length) {
        this.datePickerDouble.startDate = this.$moment(
          this.rangevalue[0]
        ).format("YYYY-MM-DD");
        this.datePickerDouble.endDate = this.$moment(this.rangevalue[1]).format(
          "YYYY-MM-DD"
        );
      } else {
        this.getCurrentDate();
      }
      this.getQuotationData();
    },

    getCurrentDate() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90); //三个月
      // this.KDatePicker = [start, end];
      this.datePickerDouble.startDate = start;
      this.datePickerDouble.endDate = end;
    },

    changeKDate() {},

    async getF10Id() {
      const { result } = await getBasic(this.id, this.code);
      const f10Id = result.f10Id;
      this.f10Id = f10Id;
      this.getQuotationData(f10Id);
      this.getDivideng(f10Id);
      this.getSummaryList(f10Id);
    },

    async getQuotationData(f10Id) {
      // console.log(this.KDatePicker);
      // if (!this.KDatePicker || !this.KDatePicker.length) return;
      // const { result } = await getKQuotation({
      //   start: this.KDatePicker[0],
      //   f10DataId: this.f10Id,
      //   end: this.KDatePicker[1]
      // });
      const { result } = await getKQuotation({
        start: this.datePickerDouble.startDate,
        f10DataId: this.f10Id,
        end: this.datePickerDouble.endDate
      });
      this.dailyKData = this.converData(result);
      console.log("this.dailyKData", this.dailyKData);
    },

    async getDivideng(f10Id) {
      const params = {
        keyword: f10Id
      };
      const { result } = await getDividend(params);
      result.recordList.forEach(item => {
        Object.keys(item).forEach(keyItem => {
          if (!item[keyItem] || item[keyItem] == "null") item[keyItem] = "";
        });
      });
      this.dividendData = result.recordList;
    },

    async getSummaryList(f10Id) {
      const params = {
        keyword: f10Id
      };
      const { result } = await getSummary(params);
      result.recordList.forEach(item => {
        item.announcement_date = item.announcement_date.split(" ")[0];
      });
      this.caSummaryData = result.recordList;
    },

    converData(data) {
      // 数据意义：开盘(open)，收盘(close)，最低(lowest)，最高(highest)
      return data.map(item => [
        item.trade_date.split(" ")[0],
        item.fopen,
        item.previous_close,
        item.low,
        item.high
      ]);
    },

    getFirstSentence(str) {
      return (
        str
          .split(" ")
          .slice(0, 20)
          .join(" ") + "..."
      );
    },

    viewDetail(content) {
      this.dialogVisible = true;
      this.content = content;
    },

    closeDialog() {
      this.dialogVisible = false;
    }
  },

  computed: {
    dateSearchDisabled() {
      return (
        !!this.datePickerDouble.startDate && !!this.datePickerDouble.endDate
      );
    }
  }
};
</script>

<style scoped>
.third_module {
  padding: 10px;
  border: 1px solid #dee2e65c;
  margin-bottom: 10px;
}

.module_title {
  font-size: 16px;
  margin-bottom: 10px;
}
.module_title .unit {
  font-size: 14px;
}
.ca_ummary >>> .el-table__row .item_data {
  white-space: pre-line !important;
}
.viewBt >>> span {
  font-size: 14px;
  vertical-align: super;
}
.daily_quotation >>> .el-date-editor .el-range-separator {
  line-height: 25px;
}
.daily_quotation >>> .el-date-editor .el-range__close-icon {
  line-height: 27px;
}
.daily_quotation >>> .el-select {
  margin-right: 15px;
  vertical-align: middle;
}
.daily_quotation >>> .el-date-editor {
  margin-right: 15px;
}
</style>